export var STATE_DELIMITER = '.';
export var EMPTY_ACTIVITY_MAP = {};
export var DEFAULT_GUARD_TYPE = 'xstate.guard';
//# sourceMappingURL=constants.js.map